import { gql, useQuery } from '@apollo/client';
import { IColumnFilterItemList, IColumnFilterQuery, IColumnFilterVariables } from '../useColumnFilter';

const queryName = 'allGroups';

export const AllGroups = gql`
    query Group($sort: [GroupSortInput], $limit: Int, $skip: Int, $filter: [GroupFilterInput]) {
        ${queryName}(filter: $filter, limit: $limit, skip: $skip, sort: $sort) {
            nodes {
                id
                description
            }
        }
    }
`;

const useAllGroups = (variables: IColumnFilterVariables) => useQuery<IColumnFilterItemList, IColumnFilterVariables>(AllGroups, { variables });

export const AllGroupsQuery: IColumnFilterQuery = {
    queryName,
    useColumnFilter: useAllGroups,
};
